import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TemplateFormsBaseComponent } from 'app/apps/template-forms/template-forms-base.component';
import { SegmentService } from 'app/segment/segment.service';
import { ErrorHandler } from 'app/shared/service/error-handler.service';
import { RouteParamsService } from 'app/shared/service/route-params.service';
import { TimingMarkerService } from 'app/shared/service/timing-marker.service';

@Component({
  selector: 'cc-template-forms-workflow',
  templateUrl: 'template-forms-workflow.component.html',
  styleUrls: ['template-forms-workflow.component.scss'],
})
export class TemplateFormsWorkflowComponent extends TemplateFormsBaseComponent implements OnInit {
  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly errorHandler: ErrorHandler,
    protected readonly routeParamsService: RouteParamsService,
    protected readonly timingMarkerService: TimingMarkerService,
    protected readonly segmentService: SegmentService,
  ) {
    super(route, router, errorHandler, routeParamsService, timingMarkerService, segmentService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.trackViewedEvent('Workflow');
  }
}
